import React from 'react'
import { AlertTriangle, ExternalLink } from 'lucide-react'
import { VacationAlert } from '@/types/dashboard'

interface VacationAlertsProps {
  vacationAlerts: VacationAlert[]
  collapse?: boolean
}

export function VacationAlerts({ vacationAlerts, collapse = true }: VacationAlertsProps) {
  if (vacationAlerts.length === 0) {
    return null
  }

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-display text-xl font-bold text-white flex items-center gap-3 bg-gradient-to-r from-white to-brand-gray-light bg-clip-text text-transparent">
          <AlertTriangle className="text-brand-red animate-pulse" size={20} />
          Alertas de Férias da Equipe ({vacationAlerts.length})
        </h3>
        <a 
          href="/vacation"
          className="text-brand-primary hover:text-white transition-all duration-300 text-sm flex items-center gap-2 font-body hover:gap-3"
        >
          Ver todos <ExternalLink size={14} className="transition-transform duration-200 hover:scale-110" />
        </a>
      </div>
      
      <div className="space-y-3">
        {(collapse ? vacationAlerts.slice(0, 3) : vacationAlerts).map((alert) => (
          <div 
            key={alert.id}
            className={`p-4 rounded-monumenta border-l-4 transition-all duration-200 hover:shadow-monumenta-lg animate-fade-in-up ${
              alert.severity === 'critical' 
                ? 'bg-brand-red/10 border-l-brand-red border border-brand-red/20 hover:border-brand-red/40' 
                : 'bg-warning/10 border-l-warning border border-warning/20 hover:border-warning/40'
            }`}
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <AlertTriangle 
                    size={16} 
                    className={`${alert.severity === 'critical' ? 'text-brand-red' : 'text-warning'} transition-transform duration-200 hover:scale-110`} 
                  />
                  <h4 className="font-display font-semibold text-white">{alert.employeeName}</h4>
                  {alert.actionRequired && (
                    <span className="text-xs px-2 py-1 bg-brand-red text-white rounded-monumenta font-display font-medium animate-pulse">
                      URGENTE
                    </span>
                  )}
                </div>
                <p className={`text-sm font-body leading-relaxed ${alert.severity === 'critical' ? 'text-brand-red' : 'text-warning'}`}>
                  {alert.message}
                </p>
                <div className="flex items-center gap-4 mt-3 text-xs text-brand-gray-light font-body">
                  <span className="bg-brand-dark/30 px-2 py-1 rounded-monumenta">Saldo: {alert.currentBalance} dias</span>
                  {alert.daysUntilAnniversary && (
                    <span className="bg-brand-dark/30 px-2 py-1 rounded-monumenta">Aniversário: {alert.daysUntilAnniversary} dias</span>
                  )}
                </div>
              </div>
              {/* <div className="flex flex-col gap-2 ml-4">
                <button className="btn-primary text-xs px-3 py-1">
                  Agendar
                </button>
                {alert.type === 'critical_balance' && (
                  <button className="btn-ghost text-xs px-3 py-1">
                    Notificar
                  </button>
                )}
              </div> */}
            </div>
          </div>
        ))}
        
        {collapse && vacationAlerts.length > 3 && (
          <div className="text-center pt-2">
            <a 
              href="/vacation"
              className="text-brand-primary hover:text-white transition-colors duration-300 text-sm"
            >
              Ver mais {vacationAlerts.length - 3} alertas
            </a>
          </div>
        )}
      </div>
    </div>
  )
}